<template>
    <head>
        <meta charset="utf-8">
        <title>Phils Pinball Database</title>
    </head>
  <body>
        <div class="u-mainNormal">
            <h1>{{ title }}</h1>
            <div class="u-flexSpaceBetween u-heading">
                <div class="u-width20">Code</div>
                <div class="u-width40">Name</div>
                <div class="u-width40">Links</div>
            </div>
            <div class="u-flexSpaceBetween" v-for="pintable in pinData" :key="'pintable' + pintable.name">
                <div class="u-width20 u-ellipsis">{{pintable.tag}}</div>
                <div class="u-width40 u-ellipsis">{{pintable.name}}</div>
                <div class="u-width40 u-ellipsis">
                    <template v-for="(link, index) in pintable.links" :key="'link' + link.linkhref">
                        <a class="u-marginRsm u-link" :href="link.linkhref">video{{index + 1}}</a><span> </span>
                    </template>
                </div>
            </div>
        </div>
    </body>
</template>

<script lang="ts">
import { Vue } from 'vue-class-component';
import { } from 'vue-property-decorator';
import { PinTable } from '../interfaces/pintable';

export default class Pinball extends Vue {
    title: string = '';
    pinData: PinTable[] = [
        {
        "tag": "6M$M",
        "name": "The Six Million Dollar Man",
        "links": [{
            "linkhref": "https://youtu.be/W1VMFpTqHSY?t=36"
            }]
        },
        {
        "tag": "8B",
        "name": "Eight Ball",
        "links": [{
            "linkhref": "https://youtu.be/-wGicmY0lYk?t=5"
            }]
        },
        {
        "tag": "ACDC",
        "name": "AC/DC",
        "links": [{
            "linkhref": "https://youtu.be/kxkgnSTltVE?t=261"
            },{
            "linkhref": "https://youtu.be/XUnw9ogKkYA?t=24029"
            },{
            "linkhref": "https://youtu.be/q90L2NTiObo?t=125"
            },{
            "linkhref": "videos\\Part5BPO-X.mp4#t=06:42:00"
            }]
        },
        {
        "tag": "AERO",
        "name": "Aerosmith",
        "links": [{
            "linkhref": "https://youtu.be/oej9gql5OTU?t=559"
            }]
        },
        {
        "tag": "AFM",
        "name": "Attack from Mars",
        "links": [{
            "linkhref": "https://youtu.be/kpi-sdpJFjc?t=73"
            }]
        },
        {
        "tag": "AVA",
        "name": "Avatar",
        "links": [{
            "linkhref": "https://youtu.be/XUnw9ogKkYA?t=15055"
            },{
            "linkhref": "videos\\Part5BPO-X.mp4#t=04:10:55"
            }]
        },
        {
        "tag": "BJ",
        "name": "Black Jack",
        "links": [{
            "linkhref": "https://youtu.be/__XTvYs1GSE?t=40"
            }]
        },
        {
        "tag": "BKSOR",
        "name": "Black Knight: Sword of Rage",
        "links": [{
            "linkhref": "https://youtu.be/lyPG3357htE?t=396"
            }]
        },
        {
        "tag": "BSD",
        "name": "Bram Stoker's Dracula",
        "links": [{
            "linkhref": "https://youtu.be/cR5mvi_edM4?t=60"
            }]
        },
        {
        "tag": "BTDK",
        "name": "Batman the dark Knight",
        "links": [{
            "linkhref": "https://youtu.be/HOXy2xpY25o?t=43"
            }]
        },
        {
        "tag": "BURO",
        "name": "Buck Rogers",
        "links": [{
            "linkhref": "https://youtu.be/lePevjDCOVE?t=12"
            }]
        },
        {
        "tag": "CD",
        "name": "Count-Down",
        "links": [{
            "linkhref": "https://youtu.be/OivgT9NXxbI?t=326"
            }]
        },
        {
        "tag": "CFTBL",
        "name": "Creature from the Black Lagoon",
        "links": [{
            "linkhref": "https://youtu.be/USGjjXcjM5w?t=668"
            }]
        },
        {
        "tag": "CON",
        "name": "Congo",
        "links": [{
            "linkhref": "https://youtu.be/HOxXGvlaMQc?t=721"
            }]
        },
        {
        "tag": "CORV",
        "name": "Corvette",
        "links": [{
            "linkhref": "https://youtu.be/F-UEWoNhrvM?t=67"
            }]
        },
        {
        "tag": "CV",
        "name": "Cirqus Voltaire",
        "links": [{
            "linkhref": "https://youtu.be/JP5Axk3VLic?t=594"
            }]
        },
        {
        "tag": "DH",
        "name": "Dirty Harry",
        "links": [{
            "linkhref": "https://youtu.be/fm0WXpLxMnM?t=64"
            }]
        },
        {
        "tag": "DM",
        "name": "Demolition Man",
        "links": [{
            "linkhref": "https://youtu.be/ylSY_jQUjs0?t=5069"
            },{
            "linkhref": "videos\\Part6BPO-X.mp4#t=07:56:35"
            }]
        },
        {
        "tag": "DP",
        "name": "Deadpool",
        "links": [{
            "linkhref": "videos\\2019SternProCircuit1.mp4#t=01:06:30"
            }]
        },
        {
        "tag": "DP",
        "name": "Dolly Parton",
        "links": [{
            "linkhref": "https://youtu.be/tUE_HaR2rBc?t=6518"
            }]
        },
        {
        "tag": "DRAG",
        "name": "Dragon",
        "links": [{
            "linkhref": "https://youtu.be/uo-EQSutnQM?t=5765"
            }]
        },
        {
        "tag": "DW",
        "name": "Doctor Who",
        "links": [{
            "linkhref": "https://youtu.be/iawmrs69jrQ?t=60"
            }]
        },
        {
        "tag": "FH",
        "name": "Funhouse",
        "links": [{
            "linkhref": "https://youtu.be/yY0GJPinballXco?t=327"
            }]
        },
        {
        "tag": "FLG",
        "name": "Flash Gordon",
        "links": [{
            "linkhref": "https://youtu.be/ylSY_jQUjs0?t=25619"
            }]
        },
        {
        "tag": "FRONT",
        "name": "Frontier",
        "links": [{
            "linkhref": "https://youtu.be/7nGOwi7qJgM?t=4690"
            }]
        },
        {
        "tag": "FS",
        "name": "The Flintstones",
        "links": [{
            "linkhref": "https://youtu.be/XUnw9ogKkYA?t=28712"
            }]
        },
        {
        "tag": "FS?",
        "name": "Flintstones",
        "links": [{
            "linkhref": "videos\\Part5BPO-X.mp4#t=08:02:40"
            }]
        },
        {
        "tag": "FT",
        "name": "Fish Tales",
        "links": [{
            "linkhref": "https://youtu.be/XUnw9ogKkYA?t=26727"
            },{
            "linkhref": "videos\\Part5BPO-X.mp4#t=08:02:40"
            },{
            "linkhref": "videos\\Part5BPO-X.mp4#t=08:25:25"
            }]
        },
        {
        "tag": "GB",
        "name": "Ghostbusters",
        "links": [{
            "linkhref": "https://youtu.be/XUnw9ogKkYA?t=267"
            }]
        },
        {
        "tag": "GEN?",
        "name": "Genesis",
        "links": [{
            "linkhref": "videos\\PAPA20Finals2017.mp4#t=00:03:40"
            },{
            "linkhref": "https://youtu.be/Y8c43MU7rqs?t=218"
            }]
        },
        {
        "tag": "GOT",
        "name": "Game of Thrones",
        "links": [{
            "linkhref": "https://youtu.be/XUnw9ogKkYA?t=22478"
            },{
            "linkhref": "videos\\Part5BPO-X.mp4#t=06:17:30"
            },{
            "linkhref": "videos\\Part5BPO-X.mp4#t=08:08:50"
            }]
        },
        {
        "tag": "GOTG",
        "name": "Guardians of the Galaxy",
        "links": [{
            "linkhref": "https://youtu.be/fk6rAZ0vARo?t=10882"
            }]
        },
        {
        "tag": "HG",
        "name": "Harlem Globetrotters on Tour",
        "links": [{
            "linkhref": "https://youtu.be/XTqu1NSmQ30?t=595"
            }]
        },
        {
        "tag": "HS2",
        "name": "Getaway: High Speed II",
        "links": [{
            "linkhref": "https://youtu.be/y_BgVLzT3I0?t=632"
            }]
        },
        {
        "tag": "I500",
        "name": "Indianapolis 500",
        "links": [{
            "linkhref": "https://youtu.be/0JJ58ZBaBxo?t=96"
            }]
        },
        {
        "tag": "IM",
        "name": "Iron Maiden",
        "links": [{
            "linkhref": "videos\\IFPA16.mp4#t=06:36:40"
            },{
            "linkhref": "videos\\IFPA16.mp4#t=02:09:30"
            }]
        },
        {
        "tag": "IM",
        "name": "Iron Man",
        "links": [{
            "linkhref": "https://youtu.be/XUnw9ogKkYA?t=10551"
            },{
            "linkhref": "videos\\Part6BPO-X.mp4#t=05:57:20"
            }]
        },
        {
        "tag": "IMDN",
        "name": "Iron Maiden (2018)",
        "links": [{
            "linkhref": "https://youtu.be/tUE_HaR2rBc?t=1138"
            },{
            "linkhref": "https://youtu.be/XUnw9ogKkYA?t=4529"
            }]
        },
        {
        "tag": "JOP",
        "name": "Joker Poker",
        "links": [{
            "linkhref": "https://youtu.be/Forr0hevMVA?t=6278"
            }]
        },
        {
        "tag": "JP2",
        "name": "Jurassic Park (Stern)",
        "links": [{
            "linkhref": "https://youtu.be/wsHKv8PFk3s?t=146"
            }]
        },
        {
        "tag": "JQ",
        "name": "Jungle Queen",
        "links": [{
            "linkhref": "videos\\PAPA20Finals2017.mp4#t=06:36:40"
            },{
            "linkhref": "videos\\PAPA20Finals2017.mp4#t=02:09:30"
            }]
        },
        {
        "tag": "JY",
        "name": "Junk Yard",
        "links": [{
            "linkhref": "https://youtu.be/pe1C9LUxn6k?t=281"
            }]
        },
        {
        "tag": "KISS",
        "name": "Kiss (Bally)",
        "links": [{
            "linkhref": "https://youtu.be/XUnw9ogKkYA?t=24849"
            },{
            "linkhref": "videos\\Part5BPO-X.mp4#t=06:55:10"
            }]
        },
        {
        "tag": "LOTR",
        "name": "The Lord of the Rings",
        "links": [{
            "linkhref": "https://youtu.be/zttZPQy1vnk?t=501"
            }]
        },
        {
        "tag": "LW",
        "name": "Lost World",
        "links": [{
            "linkhref": "https://youtu.be/xMHuvYiDMxI?t=9"
            }]
        },
        {
        "tag": "MA",
        "name": "Mousin Around!",
        "links": [{
            "linkhref": "https://youtu.be/XPbt_R9FW7E?t=2066"
            }]
        },
        {
        "tag": "MB",
        "name": "Monster Bash",
        "links": [{
            "linkhref": "https://youtu.be/XUnw9ogKkYA?t=18104"
            },{
            "linkhref": "videos\\Part5BPO-X.mp4#t=05:06:10"
            },{
            "linkhref": "videos\\Part5BPO-X.mp4#t=07:12:05"
            }]
        },
        {
        "tag": "MET",
        "name": "Metallica",
        "links": [{
            "linkhref": "https://youtu.be/XUnw9ogKkYA?t=2924"
            },{
            "linkhref": "videos\\Part5BPO-X.mp4#t=04:19:49"
            },{
            "linkhref": "videos\\Part5BPO-X.mp4#t=07:28:20"
            }]
        },
        {
        "tag": "NF",
        "name": "No Fear",
        "links": [{
            "linkhref": "https://youtu.be/ntJPqnz9OGo?t=1080"
            }]
        },
        {
        "tag": "NGG",
        "name": "No Good Gofers",
        "links": [{
            "linkhref": "https://youtu.be/kNOWXKKNqRw?t=71"
            }]
        },
        {
        "tag": "PAR",
        "name": "Paragon",
        "links": [{
            "linkhref": "https://youtu.be/S75vg7Wtf7w?t=57"
            }]
        },
        {
        "tag": "POWP",
        "name": "Power Play",
        "links": [{
            "linkhref": "https://youtu.be/rkgZsn-WvBE?t=10"
            }]
        },
        {
        "tag": "RAD!",
        "name": "Radical!",
        "links": [{
            "linkhref": "https://youtu.be/iqyxn1EH1OA?t=51"
            }]
        },
        {
        "tag": "RS",
        "name": "Road Show",
        "links": [{
            "linkhref": "videos\\Part5BPO-X.mp4#t=05:15:20"
            },{
            "linkhref": "https://youtu.be/XUnw9ogKkYA?t=1825"
            }]
        },
        {
        "tag": "SBM",
        "name": "Silverball Mania",
        "links": [{
            "linkhref": "https://youtu.be/EGNRddj_ZU0?t=430"
            }]
        },
        {
        "tag": "SHREK",
        "name": "Shrek",
        "links": [{
            "linkhref": "https://youtu.be/AJRwpatZR-w?t=1"
            }]
        },
        {
        "tag": "SK8B",
        "name": "Skateball",
        "links": [{
            "linkhref": "https://youtu.be/Y8c43MU7rqs?t=2135"
            },{
            "linkhref": "videos\\PAPA20Finals2017.mp4#t=00:35:40"
            },{
            "linkhref": "videos\\PAPA20Finals2017.mp4#t=01:47:45"
            },{
            "linkhref": "https://youtu.be/Y8c43MU7rqs?t=2140"
            }]
        },
        {
        "tag": "SM",
        "name": "Spider-man",
        "links": [{
            "linkhref": "https://youtu.be/5mqTABBa3fI?t=5012"
            }]
        },
        {
        "tag": "SNS",
        "name": "Strikes N Spares",
        "links": [{
            "linkhref": "https://youtu.be/6Q9mWnumgc8?t=19"
            }]
        },
        {
        "tag": "SOLR",
        "name": "Solar Ride",
        "links": [{
            "linkhref": "https://youtu.be/x_CYy_mICZ4?t=226"
            }]
        },
        {
        "tag": "SS",
        "name": "Scared Stiff",
        "links": [{
            "linkhref": "https://youtu.be/YOz4RxI-vnQ?t=334"
            }]
        },
        {
        "tag": "ST-B",
        "name": "Star Trek (Bally)",
        "links": [{
            "linkhref": "https://youtu.be/wYZuLK6ShUk?t=118"
            }]
        },
        {
        "tag": "SW",
        "name": "Star Wars",
        "links": [{
            "linkhref": "https://youtu.be/fk6rAZ0vARo?t=42274"
            }]
        },
        {
        "tag": "T2",
        "name": "Terminator 2",
        "links": [{
            "linkhref": "videos\\Part6BPO-X.mp4#t=06:47:52"
            }]
        },
        {
        "tag": "TF",
        "name": "Transformers",
        "links": [{
            "linkhref": "https://youtu.be/bFKvbsyt6XI?t=63"
            }]
        },
        {
        "tag": "TNA",
        "name": "Total Nuclear Annihilation",
        "links": [{
            "linkhref": "https://youtu.be/s6ZaHk1Fbys?t=57"
            }]
        },
        {
        "tag": "TOM",
        "name": "Theatre of Magic",
        "links": [{
            "linkhref": "https://youtu.be/BzLXJMNdoXs?t=69"
            }]
        },
        {
        "tag": "TOTAN",
        "name": "Tales of the Arabian Nights",
        "links": [{
            "linkhref": "https://youtu.be/XUnw9ogKkYA?t=252"
            },{
            "linkhref": "videos\\Part6BPO-X.mp4#t=07:30:5"
            }]
        },
        {
        "tag": "TRON",
        "name": "Tron: Legacy",
        "links": [{
            "linkhref": "https://youtu.be/8u1bVbwYy0U?t=21"
            }]
        },
        {
        "tag": "TS",
        "name": "The Shadow",
        "links": [{
            "linkhref": "https://youtu.be/fMxSmlqRqtE?t=816"
            }]
        },
        {
        "tag": "TWD",
        "name": "The Walking Dead",
        "links": [{
            "linkhref": "https://youtu.be/Y8c43MU7rqs?t=3194"
            },{
            "linkhref": "videos\\PAPA20Finals2017.mp4#t=00:54:40"
            }]
        },
        {
        "tag": "TZ",
        "name": "Twilight Zone",
        "links": [{
            "linkhref": "videos\\PAPA20Finals2017.mp4#t=01:41:00"
            },{
            "linkhref": "https://youtu.be/Y8c43MU7rqs?t=2135"
            }]
        },
        {
        "tag": "WCS",
        "name": "World Cup Soccer",
        "links": [{
            "linkhref": "https://youtu.be/ylSY_jQUjs0?t=14725"
            }]
        },
        {
        "tag": "VIK",
        "name": "Viking",
        "links": [{
            "linkhref": "https://youtu.be/hDu9g6RrI8g?t=840"
            }]
        },
        {
        "tag": "WM",
        "name": "Wrestlemania",
        "links": [{
            "linkhref": "https://youtu.be/hFXAC7A2Etg?t=284"
            }]
        },
        {
        "tag": "WPT",
        "name": "World Poker Tour",
        "links": [{
            "linkhref": "https://youtu.be/Y8c43MU7rqs?t=3987"
            },{
            "linkhref": "videos\\PAPA20Finals2017.mp4#t=01:06:30"
            }]
        },
        {
        "tag": "WW",
        "name": "White Water",
        "links": [{
            "linkhref": "https://youtu.be/Z7YOug3f9a4?t=2"
            }]
        },
        {
        "tag": "XENON",
        "name": "Xenon",
        "links": [{
            "linkhref": "https://youtu.be/YKWEpKjZekA?t=9"
            }]
        },
        {
        "tag": "XM",
        "name": "X-Men",
        "links": [{
            "linkhref": "https://youtu.be/Y8c43MU7rqs?t=8946"
            },{
            "linkhref": "videos\\PAPA20Finals2017.mp4#t=02:30:00"
            }]
        }
    ]

    mounted(): void {
        this.title = "Phils Pinball Database";
        // this.getData();
    }

    getData(): void {
        console.info('here we will load the data in the future');
    }
}
</script>
